import React, { useMemo } from "react";
import { Group, Text, Badge } from "@mantine/core";
import { formatOrgName } from "utils/insights";
import SortableTable from "../shared/SortableTable";

const ExternalOrgTable = ({ data = [], onRowClick, scrollAreaProps = {} }) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "organization",
        header: "Organization",
        width: "50%",
        headerStyle: { width: "50%" },
        cell: ({ row }) => (
          <Group spacing="xs">
            <div
              style={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                backgroundColor: row.original.color,
              }}
            />
            <Text weight={500}>{formatOrgName(row.original.organization)}</Text>
          </Group>
        ),
        enableSorting: false,
      },
      {
        accessorKey: "hours",
        header: "Hours Spent",
        align: "start",
        headerStyle: { textAlign: "center" },
        cellStyle: { textAlign: "start" },
        cell: ({ row }) => (
          <Badge color="blue" variant="light">
            {row.original.hours} hrs
          </Badge>
        ),
        enableSorting: true,
        sortingFn: (rowA, rowB) => {
          return rowA.original.hours - rowB.original.hours;
        },
      },
      {
        accessorKey: "meetings",
        header: "Meetings",
        align: "center",
        headerStyle: { textAlign: "center" },
        cellStyle: { textAlign: "start" },
        cell: ({ row }) => (
          <Badge color="green" variant="light">
            {row.original.meetings}
          </Badge>
        ),
        enableSorting: true,
        sortingFn: (rowA, rowB) => {
          return rowA.original.meetings - rowB.original.meetings;
        },
      },
    ],
    []
  );

  const handleRowClick = (rowData) => {
    if (onRowClick) {
      onRowClick(rowData.organization);
    }
  };

  return (
    <SortableTable
      data={data}
      columns={columns}
      onRowClick={handleRowClick}
      highlightOnHover={true}
      scrollAreaProps={{
        style: { flex: 1 },
        ...scrollAreaProps,
      }}
    />
  );
};

export default ExternalOrgTable; 